import { EC } from "@/constants/errors";
import { cn, createBEM, validateFileSize } from "@/libs";
import { LocalError } from "@/libs/errors";
import { useLatest, useSetState, useToggle } from "ahooks";
import { AutoCenter, Button, Image, ImageViewer, Loading, Toast, ImageUploader, ImageUploadItem } from "antd-mobile";
import { CloseCircleOutline } from "antd-mobile-icons";
import { Html5Qrcode } from "html5-qrcode";
import QrScanner from "qr-scanner";
import { Icon } from "../Icon";
import "./index.scss";
import { useConfigContext } from "@/app";
import * as Sentry from '@sentry/react';
export type ComponentNameProps = {
  className?: string;
  text?: string;
  onChange?(code: {
    image: string;
    decodeQRcode?: string;
  }): void;
  onUpload(file: File | Blob): Promise<string>;
  accept?: "image" | "video";
  beforeUpload?(file: File | Blob): Promise<boolean>;
  mode?: "normal" | "QRcode";
  onDelete?(): void;
};
const b = createBEM("i-uploader");
export const Uploader = ({
  className,
  text,
  onChange,
  onUpload,
  accept = "image",
  beforeUpload,
  mode = "normal",
  onDelete
}: ComponentNameProps) => {
  const {
    getSourcePath
  } = useConfigContext();
  const [visible, {
    toggle: toggleVisible
  }] = useToggle();
  const [loading, {
    toggle: toggleLoading
  }] = useToggle(false);
  const [state, setState] = useSetState({
    image: "",
    decode: ""
  });
  const latestState = useLatest(state);
  const showImagePreviewer = accept === "image" && state.image && !loading || false;
  const showUploader = (accept === "video" || !showImagePreviewer) && !loading;
  const fileUpload = async (file: File): Promise<ImageUploadItem> => {
    try {
      // const formData = new FormData();
      // formData.append("imgFile", file);
      // formData.append("type", "avatar");
      // const input = e.target;
      // const file = (input.files || [])[0];
      if (file) {
        const messages = validateFileSize(file.size, 5, "MB");
        if (messages) {
          Toast.show(messages);
          return {
            url: ''
          };
        }
        // 验证二维码
        if (mode === "QRcode") {
          const scanner = new Html5Qrcode("QRcodeScanner");
          try {
            const decode = await scanner.scanFile(file, true);
            setState({
              decode
            });
          } catch (error) {
            // TODO 上报解码错误
            try {
              const decode = await QrScanner.scanImage(file);
              setState({
                decode
              });
            } catch (error) {
              // TODO 上报解码错误
              Sentry.captureException(new Error('上报解码错误'));
              Toast.show("请上传正确的收款码");
              return {
                url: ''
              };
            }
          }
        }
        if (beforeUpload) {
          const ok = await beforeUpload(file);
          if (!ok) return {
            url: ''
          };
          ;
        }
        toggleLoading();
        const image = await onUpload(file);
        toggleLoading();
        console.log({
          image,
          decodeQRcode: latestState.current.decode
        }, "-------");
        onChange?.({
          image,
          decodeQRcode: latestState.current.decode
        });
        setState({
          image: image
        });
        return {
          url: latestState.current.decode
        };
      } else {
        throw new LocalError(EC.INVALID_FILE, "上传付款凭证，从files无法获取到文件");
      }
    } catch (error) {
      //TODO： 上传错误
      console.error(error);
      return {
        url: ''
      };
    }
  };
  return <div className={cn(b(), className)} data-sentry-component="Uploader" data-sentry-source-file="index.tsx">
      {/* Loading */}
      {loading && <AutoCenter>
          <span className={b("loading")}>上传中</span>
          <Loading />
        </AutoCenter>}
      {/* QRcodeScanner */}
      <div id="QRcodeScanner"></div>
      {/* 预览图片 */}
      {showImagePreviewer && <>
          <Image fit="contain" src={getSourcePath(state.image)} alt="付款凭证" className={b("image")} onClick={toggleVisible} />
          <ImageViewer image={getSourcePath(state.image)} visible={visible} onClose={toggleVisible} />
          <Button className={b("image-delete")} fill="none" onClick={() => {
        onDelete?.();
        setState({
          image: "",
          decode: ""
        });
        onChange?.({
          image: "",
          decodeQRcode: ""
        });
      }}>
            <CloseCircleOutline fontSize={24} />
          </Button>
        </>}

      {/* 展示上传组件 */}
      {showUploader && <>
          <Icon name="circle-uploader" size="32px" />
          {text && <span className={b("text")}>{text}</span>}
          <ImageUploader className={b("input")} multiple={false} columns={0} renderItem={() => null} preview={false} upload={fileUpload}>
            </ImageUploader>
        </>}
    </div>;
};